module.exports = __webpack_public_path__ + "img/Profile.18ab55ba.png";